export enum JobInvitationStatus {
  NONE = -1,
  SENT = 0,
  ACCEPTED = 1,
  DECLINED = 2,
  REQUESTHIRED = 3,
  HIRED = 4,
  NOTHIRED = 5,
}
